import { useContext } from 'react';
import CheckoutPageContext from '../../../context/CheckoutPageContext';
import stepsSchema from '../steps.schema.json';

const useStepsSchema = () => {
  const { checkoutPageState } = useContext(CheckoutPageContext);
  const tmntData = checkoutPageState?.textFor || {};

  const updatedSteps = stepsSchema.steps.map((step, index) => ({
    ...step,
    title: {
      ...step.title,
      value: tmntData[`steppedCheckoutStep${index + 1}Title`]?.value || step.title.value,
    },
    errorMessage: {
      ...step.errorMessage,
      value: step.errorMessage.value,
    },
    editButtonLabel: {
      ...step.editButtonLabel,
      value: tmntData?.editButton?.value || step.editButtonLabel.value,
    },
    nextButtonLabel: {
      ...step.nextButtonLabel,
      value: tmntData?.continueButton?.value || step.nextButtonLabel.value,
    },
    updateButtonLabel: {
      ...step.updateButtonLabel,
      value: tmntData?.updateButton?.value || step.updateButtonLabel.value,
    },
  }));
  return {
    ...stepsSchema,
    steps: updatedSteps,
  };
};

export default useStepsSchema;
